/**
 * @generated SignedSource<<68cbe7e3bba4d37b8a8da1b498fcc553>>
 * @relayHash 2c46d3b2c3ec73dd291acca90939639b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 419435c9f9a529fdb4e1bd08063a11a64faea8bef5365e6c5dc063f477f28151

import type { ConcreteRequest } from 'relay-runtime';
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type FolderOverviewFirstPageQuery$variables = {
  after?: string | null | undefined;
  contentId: string;
  id: string;
};
export type FolderOverviewFirstPageQuery$data = {
  readonly ptpage: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly links: {
          readonly webui: string | null | undefined;
        } | null | undefined;
        readonly properties: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null | undefined;
            readonly key: string | null | undefined;
            readonly value: string | null | undefined;
            readonly version: {
              readonly number: number | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status: PTGraphQLPageStatus | null | undefined;
        readonly subType: string | null | undefined;
        readonly title: string | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly endCursor: string | null | undefined;
        readonly hasNextPage: boolean;
      } | null | undefined;
    } | null | undefined;
    readonly id: string;
    readonly title: string | null | undefined;
  } | null | undefined;
  readonly singleContent: {
    readonly operations: ReadonlyArray<{
      readonly operation: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type FolderOverviewFirstPageQuery = {
  response: FolderOverviewFirstPageQuery$data;
  variables: FolderOverviewFirstPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = {
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    },
    {
      "kind": "Literal",
      "name": "status",
      "value": [
        "CURRENT",
        "DRAFT"
      ]
    }
  ],
  "concreteType": "PTPage",
  "kind": "LinkedField",
  "name": "ptpage",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "args": [
        {
          "kind": "Variable",
          "name": "after",
          "variableName": "after"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 40
        }
      ],
      "concreteType": "PTPaginatedPageList",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "concreteType": "PTPage",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v3/*: any*/),
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "status"
            },
            {
              "kind": "ScalarField",
              "name": "type"
            },
            {
              "kind": "ScalarField",
              "name": "subType"
            },
            {
              "concreteType": "Map_LinkType_String",
              "kind": "LinkedField",
              "name": "links",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "webui"
                }
              ]
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "keys",
                  "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                  ]
                }
              ],
              "concreteType": "PaginatedJsonContentPropertyList",
              "kind": "LinkedField",
              "name": "properties",
              "plural": false,
              "selections": [
                {
                  "concreteType": "JsonContentProperty",
                  "kind": "LinkedField",
                  "name": "nodes",
                  "plural": true,
                  "selections": [
                    (v3/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "key"
                    },
                    {
                      "kind": "ScalarField",
                      "name": "value"
                    },
                    {
                      "concreteType": "Version",
                      "kind": "LinkedField",
                      "name": "version",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "number"
                        }
                      ]
                    }
                  ]
                }
              ],
              "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
            }
          ]
        },
        {
          "concreteType": "PTPageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "hasNextPage"
            },
            {
              "kind": "ScalarField",
              "name": "endCursor"
            }
          ]
        }
      ]
    }
  ]
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v7 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FolderOverviewFirstPageQuery",
    "selections": [
      (v5/*: any*/),
      {
        "args": (v6/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "FolderOverviewFirstPageQuery",
    "selections": [
      (v5/*: any*/),
      {
        "args": (v6/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v7/*: any*/),
          (v3/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "2c46d3b2c3ec73dd291acca90939639b",
    "id": "419435c9f9a529fdb4e1bd08063a11a64faea8bef5365e6c5dc063f477f28151",
    "metadata": {},
    "name": "FolderOverviewFirstPageQuery",
    "operationKind": "query",
    "text": "query FolderOverviewFirstPageQuery($id:ID!,$after:String,$contentId:ID!){ptpage(id:$id,status:[CURRENT,DRAFT]){id,title,children(first:40,after:$after){nodes{id,title,status,type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}},singleContent(id:$contentId){operations{operation},id}}"
  }
};
})();

(node as any).hash = "40723a0edfaedade8e8d99b10993dacb";

export default node;
